import { render, staticRenderFns } from "./Crisis_editprefabrication.vue?vue&type=template&id=4af1012e"
import script from "./Crisis_editprefabrication.vue?vue&type=script&lang=js"
export * from "./Crisis_editprefabrication.vue?vue&type=script&lang=js"
import style0 from "./Crisis_editprefabrication.vue?vue&type=style&index=0&id=4af1012e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports